import Swiper, { Pagination } from 'swiper';
import '../../node_modules/swiper/swiper.css';

const init = () => {
    
    const galleryContainer = document.querySelector('.project__gallery');

    if (galleryContainer != null){

        //let currentLink = '';
        //const buttonLink = document.querySelector('.section_projects-home .button-big');

        /*
        const updateButtonLink = (swiper) => {
            let slug =  swiper.slides[swiper.activeIndex].dataset.slug;
            buttonLink.attributes.href.value = '/projects/' + slug;
        };
        */
        
        const swiper = new Swiper('.project__gallery .swiper', {
            modules: [Pagination],
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 0,
            loop: true,
            speed: 1000,
            loopedSlidesLimit: false,
            pagination: {
                el: '.project__gallery-counter',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    const newCurrent = current;
                    const newTotal = total;
                    return '(' + newCurrent +  " / " + newTotal + ')';
                }
            },
            on: {
                init: function (swiper) {
                    //updateButtonLink(swiper);
                },
            },
        });

        document.querySelector('.project__gallery .slider-go-to-next').addEventListener('click', function(){
            swiper.slideNext();
        });

        document.querySelector('.project__gallery .slider-go-to-prev').addEventListener('click', function () {
            swiper.slidePrev();
        });

        /*
        swiper.on('slideNextTransitionStart', function (swiper) {
            buttonLink.classList.add('is-going-next');
        });

        swiper.on('slideNextTransitionEnd', function (swiper) {
            buttonLink.classList.remove('is-going-next');
        });

        swiper.on('slidePrevTransitionStart', function (swiper) {
            buttonLink.classList.add('is-going-prev');
        });

        swiper.on('slidePrevTransitionEnd', function (swiper) {
            buttonLink.classList.remove('is-going-prev');
        });
        */

        /*
        const sliderArrow = document.querySelector('.project__gallery .slider-arrow');
        
        galleryContainer.addEventListener('mouseenter', function (e) {
            sliderArrow.classList.add('is-active');

            e.target.addEventListener('mousemove', function (e) {
                sliderArrow.style.left = e.offsetX + 'px';
                sliderArrow.style.top = e.offsetY + 'px';
            });
        });

        galleryContainer.addEventListener('mouseleave', function (e) {
            sliderArrow.classList.remove('is-active');
            sliderArrow.style.left = '25%';
            sliderArrow.style.top = '50%';
        });
        */
            
    };

    /*
    const projectsList = document.querySelectorAll('.projects-list');

    if(projectsList.length > 0){

        projectsList.forEach((el) => {

            let swiper = new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: false,
                speed: 1000,
                on: {
                    init: function (swiper) {
                        //updateButtonLink(swiper);
                    },
                },
            });
            
        });
    }
    */
};

export default { init };